/* import __COLOCATED_TEMPLATE__ from './remove-tag-from-conversation.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import type RemoveTagFromConversation from 'embercom/models/operator/visual-builder/step/remove-tag-from-conversation';
import type EditorState from 'embercom/objects/workflows/graph-editor/editor-state';

interface RemoveTagFromConversationArgs {
  step: RemoveTagFromConversation;
  editorState: EditorState;
  readOnly: boolean;
  actionEditorContext: $TSFixMe;
  onChange: () => void;
  onDelete: () => void;
  rule: $TSFixMe;
}

interface Signature {
  Element: HTMLDivElement;
  Args: RemoveTagFromConversationArgs;
}

export default class RemoveTagFromConversationNodeItem extends Component<Signature> {
  get allRuleActions() {
    return this.steps.mapBy('firstSimpleAction').reject((action: $TSFixMe) => !action);
  }

  get steps() {
    return this.group.steps;
  }

  get group() {
    return this.args.step.group;
  }

  get shouldShowError() {
    return this.args.editorState.shouldShowValidations && !this.args.step.validations.isValid;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::RemoveTagFromConversation': typeof RemoveTagFromConversationNodeItem;
    'workflows/graph-editor/node-items/steps/remove-tag-from-conversation': typeof RemoveTagFromConversationNodeItem;
  }
}
